import { render, staticRenderFns } from "./CustomPinned.vue?vue&type=template&id=4f23c072&scoped=true&"
import script from "./CustomPinned.vue?vue&type=script&lang=js&"
export * from "./CustomPinned.vue?vue&type=script&lang=js&"
import style0 from "./CustomPinned.vue?vue&type=style&index=0&id=4f23c072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f23c072",
  null
  
)

export default component.exports